import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import Landing from "./pages/landing/Landing";
import Video from "./pages/landing/Video";
import Tutorial from "./pages/tutorial/Tutorial";
import PublicEntrance from "./pages/locations/PublicEntrance";
import CopperGate from "./pages/locations/CopperGate";
import Chambers from "./pages/locations/Chambers";
import NotFound from "./pages/general/NotFound";
import ExhibitsArea from "./pages/locations/ExhibitsArea";
import SilverDoor from "./pages/locations/SilverDoor";
import PortraitCollection from "./pages/locations/PortraitCollection";
import CommitteeRooms from "./pages/locations/CommitteeRooms";
import ParliamentLibrary from "./pages/locations/ParliamentLibrary";
import MinisterEntrance from "./pages/locations/MinisterEntrance";
import PortraitCollectionSecondFloor from "./pages/locations/PortraitCollectionSecondFloor";
import ExitVideo from "./pages/landing/ExitVideo";
import LoginPage from "./pages/landing/Login";
import ProtectedRoute from "./pages/general/ProtectedRoute";
import {
  ThemeAudioContext,
  ThemeAudioProvider,
} from "./components/ThemeAudioContext";
import axios from "axios";
import { useContext, useEffect } from "react";

function App() {
  let location = useLocation();

  return (
    <div className="App">
      <ThemeAudioProvider>
        <AppContent />
      </ThemeAudioProvider>
    </div>
  );
}

// Separate component inside the provider
const AppContent = () => {
  const { setAudioSource } = useContext(ThemeAudioContext);

  useEffect(() => {
    const getGlobalSettings = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_API + "GlobalSettings/getGlobalSettings"
        );

        const audioUrl = response.data?.themeAudio;

        if (audioUrl) {
          setAudioSource(audioUrl);
        }
      } catch (error) {
        console.error(error);
      }
    };

    getGlobalSettings();
  }, [setAudioSource]);

  return (
    <Routes>
      <Route path="/" element={<LoginPage />}></Route>
      <Route
        path="/parliament-tour"
        element={
          // <ProtectedRoute>
            <Landing />
          // </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/video"
        element={
          // <ProtectedRoute>
            <Video />
          // </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/exit-video"
        element={
          // <ProtectedRoute>
            <ExitVideo />
          // </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/tutorial"
        element={
          // <ProtectedRoute>
            <Tutorial />
          // </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/public-entrance"
        element={
          // <ProtectedRoute>
            <PublicEntrance />
          // </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/exhibits-area"
        element={
          // <ProtectedRoute>
            <ExhibitsArea />
          // </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/copper-gate"
        element={
          // <ProtectedRoute>
            <CopperGate />
          // </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/silver-door"
        element={
          // <ProtectedRoute>
            <SilverDoor />
          // </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/chamber"
        element={
          // <ProtectedRoute>
            <Chambers />
          // </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/portrait-collection"
        element={
          // <ProtectedRoute>
            <PortraitCollection />
          // </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/portrait-collection-second-floor"
        element={
          // <ProtectedRoute>
            <PortraitCollectionSecondFloor />
          // </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/committee-rooms"
        element={
          // <ProtectedRoute>
            <CommitteeRooms />
          // </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/parliament-library"
        element={
          // <ProtectedRoute>
            <ParliamentLibrary />
          // </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/minister-entrance"
        element={
          // <ProtectedRoute>
            <MinisterEntrance />
          // </ProtectedRoute>
        }
      ></Route>
      <Route path="*" element={<NotFound />}></Route>
    </Routes>
  );
};

export default App;
